import { Typography } from "@pondigitalsolutions/pon-component-library";
import { ISbStoryData } from "@storyblok/react";
import { twMerge } from "tailwind-merge";
import { formatDate } from "../../utils/date";
import { languageDutch } from "../../i18n";
import { DateFormatNL, DateFormatEN } from "../../constants";
import { useCurrentLang } from "@hooks/useCurrentLang";

interface NewsMetaDataProps {
  brand?: ISbStoryData[];
  categories?: ISbStoryData[];
  cluster?: string;
  date: string;
  className?: string;
  dateFormat?: "long" | "short";
}

export const NewsMetaData = ({
  brand,
  categories,
  cluster,
  date,
  className,
  dateFormat = "short",
}: NewsMetaDataProps) => {
  const currentLang = useCurrentLang();

  return (
    <div
      className={twMerge(
        "flex gap-1 *:font-semibold *:text-tertiary-600 lg:*:text-sm dark:*:text-tertiary-300",
        className
      )}
    >
      {Array.isArray(brand) && brand.length > 0 && (
        <Typography size="xs">
          {brand.length === 1
            ? `${brand[0].name} • `
            : `${brand.length} brands • `}
        </Typography>
      )}
      {cluster && <Typography size="xs">{`${cluster} • `}</Typography>}
      {categories?.[0]?.name && (
        <Typography size="xs">{`${categories[0].name} • `}</Typography>
      )}
      <Typography size="xs">
        {formatDate(
          date,
          currentLang === languageDutch ? DateFormatNL : DateFormatEN,
          dateFormat
        )}
      </Typography>
    </div>
  );
};
